/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../services/globalsettingsservice.ts" />
/// <reference path="iscreencontroller.d.ts" />
/// <reference path="../services/addressfinderservice.ts" />


module App.Common.Controllers {
    'use strict';

    export class AddressFinderController {

        public static $inject = ['$scope', '$injector'];

        public model: Hca.HiLO.ViewModel.IAddressFinderViewModel;
        public targetAddress: Hca.HiLO.ViewModel.IAddressViewModel;
        public api: Common.Services.ApiService;
        public globalSettings: Common.Services.GlobalSettingsService;
        public showManualEntry = false;
        public header: string;

        public postCodeInvalidMessage = 'The postcode is not in the correct format.';
        public doorNumberInvalidMessage = 'The door number is not in the correct format.';

        private doorNumberRegexp = /[0-9]{1,4}[A-Z]?/i;

        public showNoMatchingAddressesError = false;
        public postCodeInvalid = false;
        public postCodeRequired = false;
        public busyPromise: angular.IPromise<any>;

        constructor(private $scope: angular.IScope, $injector: angular.auto.IInjectorService) {
            this.api = $injector.get<Common.Services.ApiService>('app.common.services.apiService');
            this.globalSettings = $injector.get<Common.Services.GlobalSettingsService>('app.common.services.globalSettingsService');
            this.targetAddress = this['ngModel'];
            this.header = this['header'];

            if (angular.isDefined(this.targetAddress) && this.targetAddress != null && this.targetAddress.line1 != null && this.targetAddress.line1 !== '') {
                this.showManualEntry = true;
            }

        }

		/* retrieve a list of addresses based on  
		   the postcode and door number provided */
        public findAddress(): void {
            this.targetAddress = this['ngModel'];
            //reset validation
            this.postCodeRequired = false;
            this.postCodeInvalid = false;
            this.showNoMatchingAddressesError = false;

            //validate
            if (angular.isUndefined(this.model) || this.model.postCode === null || this.model.postCode === '') {
                this.postCodeRequired = true;
                return;
            }
            else if (!this.globalSettings.postcodeRegexp.test(this.model.postCode)) {
                this.postCodeInvalid = true;
                return;
            }

			/* call TMS address api,
			   which will then call address finder service, 
			   which will then call the ordanance survey api */
            this.busyPromise = this.api.get({
                resourceName: 'Address',
                params: { postcode: this.model.postCode }
            }).then((data: Hca.HiLO.ViewModel.IAddressSummaryViewModel[]): any => {
                this.model.addresses = data;
                if (this.model.addresses === null || this.model.addresses.length === 0) {
                    this.showNoMatchingAddressesError = true;
                } else if (this.model.addresses.length === 1) {
                    //only 1 found? selected it
                    this.model.selectedAddress = this.model.addresses[0];
                    angular.copy(this.model.selectedAddress, this.targetAddress);
                }
            });
        }

		/* when ngModel is provided in the html declaration
		   assign the currently selected address to it */
        public addressChange() {
            if (angular.isDefined(this['ngModel'])) {
                angular.copy(this.model.selectedAddress, this.targetAddress);
            }
            //hide manual address entry panel
            this.showManualEntry = true;
     
        }

        /* when addresses are populated enable their selection */
        public enableAddresses(): boolean {
            return angular.isDefined(this.model)
                && this.model.addresses != null
                && this.model.addresses.length > 0;
        }

        /* handler for key pressing on the postcode input */
        public addressFinderKeyPress(keyEvent): boolean {
            //hit enter? search
            if (keyEvent.which === 13) {
                this.findAddress();
                keyEvent.preventDefault();
                return false;
            }
            return true;
        }

        public isAddressFinderInvalid(): boolean {
            return this.showNoMatchingAddressesError || this.postCodeInvalid || this.postCodeRequired;
        }

    }
}